import { fetch } from 'whatwg-fetch';
export const get = (url, throwError = true) => _fetch(url, 'GET', undefined, undefined, throwError);
export const post = (url, data, abortController = null, throwError = true) => _fetch(url, 'POST', data, abortController, throwError);
export const put = (url, data, abortController = null, throwError = true) => _fetch(url, 'PUT', data, abortController, throwError);
export const patch = (url, data, abortController = null, throwError = true) => _fetch(url, 'PATCH', data, abortController, throwError);
export const remove = (url, data, abortController = null, throwError = true) => _fetch(url, 'DELETE', data, abortController, throwError);
const _fetch = (url, method, data = null, abortController = null, throwError = true) => {
    let options = {
        method,
        headers: {
            'litium-request-context': JSON.stringify(window.__litium.requestContext),
        },
        credentials: 'include',
    };
    if (abortController) {
        options.signal = abortController.signal;
    }
    if (method !== 'GET') {
        options = {
            ...options,
            body: data ? JSON.stringify(data) : null,
            headers: {
                ...options.headers,
                'content-type': 'application/json',
            },
        };
        const token = window.localStorage.getItem('requestVerificationToken');
        if (token) {
            options = {
                ...options,
                headers: {
                    ...options.headers,
                    RequestVerificationToken: token,
                },
            };
        }
    }
    // use native browser implementation if it supports aborting
    const abortableFetch = 'signal' in new Request('') ? window.fetch : fetch;
    return abortableFetch(url, options).then((response) => _checkStatus(response, throwError));
};
const _checkStatus = (response, throwError) => {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    else {
        let error = new Error(response.statusText);
        error.response = response;
        if (throwError) {
            throw error;
        }
        return response;
    }
};
